function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.84375 1.36816C3.84375 1.09202 4.06761 0.868164 4.34375 0.868164H9.34375C9.61989 0.868164 9.84375 1.09202 9.84375 1.36816C9.84375 1.64431 9.61989 1.86816 9.34375 1.86816H4.34375C4.06761 1.86816 3.84375 1.64431 3.84375 1.36816ZM0.843262 3.36827C0.843262 3.09213 1.06712 2.86827 1.34326 2.86827H2.34326H11.3433H12.3433C12.6194 2.86827 12.8433 3.09213 12.8433 3.36827C12.8433 3.64441 12.6194 3.86827 12.3433 3.86827H11.8433V12.8683C11.8433 13.1335 11.7379 13.3878 11.5504 13.5754C11.3628 13.7629 11.1085 13.8683 10.8433 13.8683H2.84326C2.57805 13.8683 2.32369 13.7629 2.13616 13.5754C1.94862 13.3878 1.84326 13.1335 1.84326 12.8683V3.86827H1.34326C1.06712 3.86827 0.843262 3.64441 0.843262 3.36827ZM2.84326 3.86827V12.8683H10.8433V3.86827H2.84326Z",
  fill: "black"
});

var SvgBin = function SvgBin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Bin.dabafe24.svg";
export { ForwardRef as ReactComponent };